import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/SimilarArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/node_modules/next/dist/client/image-component.js");
